<template>
  <div>
    <modal v-if="visible">
      <template v-slot:header>
        <h5 class="modal-title">{{$t('form.messages.remove-message-confirmation.title')}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
          <span aria-hidden="true"><img src="@/assets/img/static/b-icon_close_x.svg" alt=""></span>
        </button>
      </template>

      <template v-slot:body>
        <p class="u-text-center">{{$t('form.messages.remove-message-confirmation.text')}}</p>
      </template>

      <template v-slot:footer>
        <button class="gui-btn gui-btn--white-border gui-btn--w-184" @click.prevent="$emit('cancel')">{{$t('buttons.cancel')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-184" @click.prevent="$emit('confirm')">{{$t('buttons.delete-message')}}</button>
      </template>
    </modal>
  </div>
</template>

<script>
  import Modal from '@/widgets/modal'

  export default {
    components: {
      Modal
    },

    data: () => ({
      visible: false
    }),

    methods: {
      open() { this.visible = true; },
      close() { this.visible = false; }
    }
  }
</script>

<style scoped>

</style>
